module.exports = __webpack_public_path__ + "media/images/mail_letter-807493934b7bf9f2b34f0d53ba9c07da.png";